/**
 * Форматирует адрес: убирает слово "улица" и заменяет "кв." на запятую
 * Примеры: 
 * - "улица Урванцева, 10 кв.197" -> "Урванцева, 10, 197"
 * - "ул. Семенова, 37, кв.41" -> "Семенова, 37, 41"
 */
export function formatAddress(address: string): string {
  if (!address) return '';
  
  let formatted = address;
  
  // Убираем "ул." и "улица" в начале или после пробела
  formatted = formatted.replace(/^ул\.\s+/gi, ''); // в начале строки
  formatted = formatted.replace(/^улица\s+/gi, ''); // в начале строки
  formatted = formatted.replace(/\s+ул\.\s+/gi, ' '); // в середине
  formatted = formatted.replace(/\s+улица\s+/gi, ' '); // в середине
  
  // Заменяем ", кв." и " кв." на ", " (с учетом разных вариантов)
  formatted = formatted.replace(/,?\s*кв\.?\s*/gi, ', ');
  
  // Убираем повторяющиеся запятые и пробелы
  formatted = formatted.replace(/,\s*,+/g, ','); // ,, -> ,
  formatted = formatted.replace(/\s+,/g, ',');    // пробел перед запятой
  formatted = formatted.replace(/,\s+/g, ', ');   // нормализуем пробелы после запятых
  formatted = formatted.replace(/^\s*,\s*/, '');  // запятая в начале
  
  return formatted.trim();
}

